/**
 * 目次リスト表示コンポーネント（開閉可能）
 */

import React, { useState } from "react";
import type { ContentTocProps } from "../../utils/extractContentToc";
import STContentToc from "../../assets/styles/organisms/contentToc.module.scss";

/** 目次リストを表示するコンポーネント */
export const ContentToc: React.FC<{ toc: ContentTocProps[] }> = ({ toc }) => {
  const [isOpen, setIsOpen] = useState(true);

  if (toc.length === 0) return <></>;

  return (
    <div className={STContentToc.content_toc}>
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className={STContentToc.content_toc_button}
        aria-expanded={isOpen}
        aria-controls="content-toc-list"
      >
        目次
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor"
          className={`${STContentToc.content_toc_button_icon} ${
            isOpen
              ? STContentToc.content_toc_button_icon_up
              : STContentToc.content_toc_button_icon_down
          }`}
          aria-hidden
        >
          <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
        </svg>
      </button>
      {isOpen && (
        <ul id="content-toc-list" className={STContentToc.content_toc_list}>
          {toc.map((anchor, index) => (
            <li
              key={index}
              className={
                STContentToc[`toc-level-${anchor.level}`] ??
                STContentToc["toc-level-1"]
              }
            >
              <a href={`#${anchor.id}`}>{anchor.text}</a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
